/* tslint:disable */
/* eslint-disable */
/**
 * MedServer
 * API for managing esklepios resources.
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface FinancialGroupReminderSettings
 */
export interface FinancialGroupReminderSettings {
    /**
     * Unique identifier of the financial group
     * @type {number}
     * @memberof FinancialGroupReminderSettings
     */
    id?: number;
    /**
     * the title for reminder 1
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderTitle1?: string;
    /**
     * the title for reminder 2
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderTitle2?: string;
    /**
     * the title for reminder 3
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderTitle3?: string;
    /**
     * the text for reminder 1
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderText1?: string;
    /**
     * the text for reminder 2
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderText2?: string;
    /**
     * the text for reminder 3
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderText3?: string;
    /**
     * the fee for reminder 1
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderFee1?: string;
    /**
     * the fee for reminder 2
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderFee2?: string;
    /**
     * the fee for reminder 3
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderFee3?: string;
    /**
     * the fee label for reminder 1
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderFeeLabel1?: string;
    /**
     * the fee label for reminder 2
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderFeeLabel2?: string;
    /**
     * the fee label for reminder 3
     * @type {string}
     * @memberof FinancialGroupReminderSettings
     */
    reminderFeeLabel3?: string;
    /**
     * create reminder document for reminder 1
     * @type {boolean}
     * @memberof FinancialGroupReminderSettings
     */
    hasCreateReminderDocument1?: boolean;
    /**
     * create reminder document for reminder 2
     * @type {boolean}
     * @memberof FinancialGroupReminderSettings
     */
    hasCreateReminderDocument2?: boolean;
    /**
     * create reminder document for reminder 3
     * @type {boolean}
     * @memberof FinancialGroupReminderSettings
     */
    hasCreateReminderDocument3?: boolean;
    /**
     * create reminder bill for reminder 1
     * @type {boolean}
     * @memberof FinancialGroupReminderSettings
     */
    hasCreateReminderBill1?: boolean;
    /**
     * create reminder bill for reminder 2
     * @type {boolean}
     * @memberof FinancialGroupReminderSettings
     */
    hasCreateReminderBill2?: boolean;
    /**
     * create reminder bill for reminder 3
     * @type {boolean}
     * @memberof FinancialGroupReminderSettings
     */
    hasCreateReminderBill3?: boolean;
}

/**
 * Check if a given object implements the FinancialGroupReminderSettings interface.
 */
export function instanceOfFinancialGroupReminderSettings(value: object): value is FinancialGroupReminderSettings {
    return true;
}

export function FinancialGroupReminderSettingsFromJSON(json: any): FinancialGroupReminderSettings {
    return FinancialGroupReminderSettingsFromJSONTyped(json, false);
}

export function FinancialGroupReminderSettingsFromJSONTyped(json: any, ignoreDiscriminator: boolean): FinancialGroupReminderSettings {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'] == null ? undefined : json['id'],
        'reminderTitle1': json['reminderTitle1'] == null ? undefined : json['reminderTitle1'],
        'reminderTitle2': json['reminderTitle2'] == null ? undefined : json['reminderTitle2'],
        'reminderTitle3': json['reminderTitle3'] == null ? undefined : json['reminderTitle3'],
        'reminderText1': json['reminderText1'] == null ? undefined : json['reminderText1'],
        'reminderText2': json['reminderText2'] == null ? undefined : json['reminderText2'],
        'reminderText3': json['reminderText3'] == null ? undefined : json['reminderText3'],
        'reminderFee1': json['reminderFee1'] == null ? undefined : json['reminderFee1'],
        'reminderFee2': json['reminderFee2'] == null ? undefined : json['reminderFee2'],
        'reminderFee3': json['reminderFee3'] == null ? undefined : json['reminderFee3'],
        'reminderFeeLabel1': json['reminderFeeLabel1'] == null ? undefined : json['reminderFeeLabel1'],
        'reminderFeeLabel2': json['reminderFeeLabel2'] == null ? undefined : json['reminderFeeLabel2'],
        'reminderFeeLabel3': json['reminderFeeLabel3'] == null ? undefined : json['reminderFeeLabel3'],
        'hasCreateReminderDocument1': json['hasCreateReminderDocument1'] == null ? undefined : json['hasCreateReminderDocument1'],
        'hasCreateReminderDocument2': json['hasCreateReminderDocument2'] == null ? undefined : json['hasCreateReminderDocument2'],
        'hasCreateReminderDocument3': json['hasCreateReminderDocument3'] == null ? undefined : json['hasCreateReminderDocument3'],
        'hasCreateReminderBill1': json['hasCreateReminderBill1'] == null ? undefined : json['hasCreateReminderBill1'],
        'hasCreateReminderBill2': json['hasCreateReminderBill2'] == null ? undefined : json['hasCreateReminderBill2'],
        'hasCreateReminderBill3': json['hasCreateReminderBill3'] == null ? undefined : json['hasCreateReminderBill3'],
    };
}

export function FinancialGroupReminderSettingsToJSON(json: any): FinancialGroupReminderSettings {
    return FinancialGroupReminderSettingsToJSONTyped(json, false);
}

export function FinancialGroupReminderSettingsToJSONTyped(value?: FinancialGroupReminderSettings | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'reminderTitle1': value['reminderTitle1'],
        'reminderTitle2': value['reminderTitle2'],
        'reminderTitle3': value['reminderTitle3'],
        'reminderText1': value['reminderText1'],
        'reminderText2': value['reminderText2'],
        'reminderText3': value['reminderText3'],
        'reminderFee1': value['reminderFee1'],
        'reminderFee2': value['reminderFee2'],
        'reminderFee3': value['reminderFee3'],
        'reminderFeeLabel1': value['reminderFeeLabel1'],
        'reminderFeeLabel2': value['reminderFeeLabel2'],
        'reminderFeeLabel3': value['reminderFeeLabel3'],
        'hasCreateReminderDocument1': value['hasCreateReminderDocument1'],
        'hasCreateReminderDocument2': value['hasCreateReminderDocument2'],
        'hasCreateReminderDocument3': value['hasCreateReminderDocument3'],
        'hasCreateReminderBill1': value['hasCreateReminderBill1'],
        'hasCreateReminderBill2': value['hasCreateReminderBill2'],
        'hasCreateReminderBill3': value['hasCreateReminderBill3'],
    };
}

